let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f81NA")).then(() => parcelRequire('9lsQo'));